module.exports = __webpack_public_path__ + "img/body3-bullet.ea09f76d.svg";